import { useShift } from 'modules/shift';
import { CommentView } from './CommentView';

export const LocationCommentView = () => {
  const { shift } = useShift();

  if (!shift) return null;

  const { locationComment } = shift;

  if (!locationComment) return null;

  return <CommentView comment={locationComment} pt={2} />;
};
